import moment from "moment";
import { PaginationV2 } from "./Pagination";
import { Pagination } from "./Pagination";
import { OptionsClass } from "./MainApp";
import { flags } from "@/feature-flags";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import { AwbDetail } from "./NGen";
import { LocationController } from "@/app/ui/controllers/LocationController";
import {
  normalizePayloadNumber,
  toNumber
} from "@/app/infrastructures/misc/common-library/NormalizePayloadNumber";
import { formatInputDecimalOnly2Digits } from "@/app/infrastructures/misc/Utils";

export class CargoV2AircraftInfo {
  manufacturer = "";
  aircraftType = "";
  version = "";
  bodyType = "";
  constructor(fields?: Partial<CargoV2AircraftInfo>) {
    Object.assign(this, fields);
  }
}

export class CargoV2SearchFlightItinerary {
  dailyFlightNo = "";
  flightNo = "";
  departureDate = "";
  arrivalDate = "";
  originAirportCode = "";
  destinationAirportCode = "";
  isDgAllowed = false;
  capacityAvailable = false;
  dimensionAvailable = false;
  historyDepartureStatus: "" | "delayed" | "on time" = "";
  embargo = false;
  remainingCapacity = 0;
  remainingCapacityAllotment = 0;
  remainingCapacityFreesales = 0;
  totalTravelTimeMin = 0;
  aircraftInfo = new CargoV2AircraftInfo();
  isTransit = false;
  isFlightVia = false;
  sequence = 0;

  constructor(fields?: Partial<CargoV2SearchFlightItinerary>) {
    Object.assign(this, fields);
  }
}

export class CargoV2SearchFlight {
  uniqueId = "";
  departureDate = "";
  arrivalDate = "";
  originAirportCode = "";
  destinationAirportCode = "";
  departureTime = 0;
  arrivalTime = 0;
  transitNumber = 0;
  orderId = 0;
  isRecommended = false;
  isDgAllowed = false;
  capacityAvailable = false;
  dimensionAvailable = false;
  isVolumeAvailability = false;
  historyDepartureStatus: "" | "delayed" | "on time" = "";
  embargo = false;
  remainingCapacity = 0;
  totalTravelTimeMin = 0;
  totalLeg = 2;
  itineraries: CargoV2SearchFlightItinerary[] = [];
  embargoReason = "";
  isFlightVia = false;
  isTransit = false;
  isDirect = false;

  constructor(fields?: Partial<CargoV2SearchFlight>) {
    Object.assign(this, fields);
  }
}

export class CargoV2SearchFlightResult {
  data: CargoV2SearchFlight[] = [];
  totalFlight = 0;
  departureDateStart = "";
  departureDateEnd = "";
  originAirports: string[] = [];
  destinationAirports: string[] = [];

  constructor(fields?: Partial<CargoV2SearchFlightResult>) {
    Object.assign(this, fields);
  }
}

export class CargoV2Entities {
  pagination = new PaginationV2();
  data: CargoV2Data[] = [];

  constructor(fields?: Partial<CargoV2Entities>) {
    Object.assign(this, fields);
  }
}

export class CargoV2FlightDetail {
  cfNumber = "";
  cfEstDepartureTime = "";
  cfAirportOrigin = "";
  cfAirportDestination = "";
  cfEstArrivalTime = "";
  isTransit = false;
  isFlightVia = false;

  constructor(fields?: Partial<CargoV2FlightDetail>) {
    Object.assign(this, fields);
  }
}

export class CargoV2DetailBagData {
  bagCustomGrossWeight = 0;
  bagGrossWeight = 0;
  bagCustomLength = 0;
  bagCustomWidth = 0;
  bagCustomHeight = 0;
  bagTotalChargeableWeight = 0;
  bagCustomChargeableWeight = 0;
  bagCustomVolumeWeight = 0;
  totalSttChargeableWeight = 0;
  totalSttGrossWeight = 0;
  totalSttVolumeWeight = 0;
  isUseNewCalculation = false;

  constructor(fields?: Partial<CargoV2DetailBagData>) {
    Object.assign(this, fields);
  }
}

export class CargoV2DetailSttPiece {
  sttPieceLength = 0;
  sttPieceWidth = 0;
  sttPieceHeight = 0;
  sttPieceGrossWeight = 0;
  sttPieceVolumeWeight = 0;

  constructor(fields?: Partial<CargoV2DetailSttPiece>) {
    Object.assign(this, fields);
  }
}

export class CargoV2DetailStt {
  baggingNumber = "";
  baggingVendorNumber = "";
  baggingVendorNo = "";
  sttNumber = "";
  totalPieces = 0;
  grossWeigth = 0;
  volumeWeight = 0;
  productType = "";
  commodity = "";
  action = "";
  origin = "";
  destination = "";
  sttTotalPiece = 0;
  sttGrossWeight = 0;
  sttVolumeWeight = 0;
  sttProductType = "";
  sttCommodityName = "";
  sttOriginCityId = 0;
  sttDestinationCityId = 0;
  destinationCityCode = "";
  destinationCityName = "";
  regionId = "";
  regionName = "";
  commodityGroupCode = "";
  commodityGroupName = "";
  commodityGroupIsDg = false;
  commodityGroupIsQuarantine = false;
  commodityGroup = "";
  shcCode = "";
  shcName = "";
  sttElexysNumber = "";
  bagCustomGrossWeight = 0;
  isFromRebooking = false;
  sttNoRefExternal = "";
  bagData = new CargoV2DetailBagData();
  bagGrossWeight = 0;
  bagCustomVolumeWeight = 0;
  bagCustomLength = 0;
  bagCustomWidth = 0;
  bagCustomHeight = 0;
  sttPieces: CargoV2DetailSttPiece[] = [];
  isScanByBag = false;
  bagCustomChargeableWeight = 0;
  bagTotalChargeableWeight = 0;
  chargeableWeight = 0;
  grossWeight = 0;
  customGrossWeight = 0;
  customChargeableWeight = 0;
  customVolumeWeight = 0;
  totalSttChargeableWeight = 0;
  totalSttGrossWeight = 0;
  totalSttVolumeWeight = 0;
  isDisputeBagging = false;
  shipmentId = "";
  sttShipmentId = "";
  isDangerousGoods = false;
  isQuarantine = false;
  bagPhotoProof: string[] = [];
  sttDetails: CargoV2DetailStt[] = [];
  sttClientId = 0;

  constructor(fields?: Partial<CargoV2DetailStt>) {
    Object.assign(this, fields);

    if (!fields?.sttDetails) {
      this.sttDetails = [];
    }
  }
}

export class DimensionCustomData {
  pieces = 0;
  length = 30;
  width = 20;
  height = 10;
  grossWeight = 0;
  volumeWeight = 0;
  sttOrBag = "";
  constructor(fields?: Partial<DimensionCustomData>) {
    Object.assign(this, fields);
  }
}

export class DimensionData {
  length = 90;
  width = 60;
  height = 0;
  constructor(fields?: Partial<DimensionData>) {
    Object.assign(this, fields);
  }
}

export class ActualDimensionData {
  cargoActualLengthDimension = 90;
  cargoActualWidthDimension = 60;
  cargoActualHeightDimension = 0;
  constructor(fields?: Partial<ActualDimensionData>) {
    Object.assign(this, fields);
  }
}

export class EstimationDimensionData {
  cargoEstHeightDimension = 0;
  cargoEstLengthDimension = 0;
  cargoEstWidthDimension = 0;
  constructor(fields?: Partial<EstimationDimensionData>) {
    Object.assign(this, fields);
  }
}

export class CargoV2Data {
  totalFlight = 0;
  id = 0;
  cargoNumber = "";
  cargoHubName = "";
  bookingRequestId = "";
  isFromRtc = false;
  cargoType = "";
  vehiclePoliceNumber = "";
  driverName = "";
  originCityCode = "";
  originCityName = "";
  originCountryCode = "";
  destinationCityCode = "";
  destinationCityName = "";
  destinationCountryCode = "";
  airportOriginCityCode = "";
  airportOriginCityName = "";
  airportDestinationCityCode = "";
  airportDestinationCityName = "";
  originDistrictCode = "";
  destinationDistrictCode = "";
  totalStt = 0;
  totalPieces = 0;
  totalGrossWeight = 0;
  totalVolumeWeight = 0;
  sttTotalPiece = 0;
  sttGrossWeight = 0;
  sttVolumeWeight = 0;
  sttProductType = "";
  sttCommodityName = "";
  sttOriginCityId = 0;
  sttDestinationCityId = 0;
  noBag = "";
  createdName = "";
  createdAt = "";
  updatedByName = "";
  totalEstCargoGrossWeight = 0;
  totalEstCargoVolumeWeight = 0;
  totalActualCargoGrossWeight: any = 0;
  totalActualCargoVolumeWeight: any = 0;
  totalChargeableWeight: any = 0;
  cargoActualPiece = 0;
  partnerName = "";
  partnerType = "";
  cargoCommodity = "";
  cargoCommodityCode = "";
  cargoProduct = "";
  cargoProductCode = "";
  shcCode = "";
  shcDescription = "";
  estimationDepartureData = "";
  estimationDepartureDate = "";
  departureDate = "";
  departureTime = "";
  estimationArrivalDate = "";
  arrivalDate = "";
  arrivalTime = "";
  nGenCreatedAt = "";
  createdBy = "";
  updatedAt = "";
  updatedBy = "";
  detailStt = [] as CargoV2DetailStt[];
  cargoDimensionCustom = [] as DimensionCustomData[];
  flightsDetail = [] as CargoV2FlightDetail[];
  cargoLabelFlightSegments = [] as CargoV2FlightDetail[];
  totalPiecesBagStt = 0;
  totalPiecesDimension = 0;
  totalGrossDimension = 0;
  actualDimension: DimensionData = new DimensionData();
  estDimension: DimensionData = new DimensionData();
  nog = "";
  partnerId = 0;
  cargoStatus = "";
  flightNumbers = [] as any;
  reasonFailed = "";
  transit = 0;
  isPlaneManual = false;
  isUseSabre = false;
  isOverCutoffTime = false;
  flightPlaneForECargo: Record<string, string | number>[] = [];
  photoProof: string[] = [];
  isAllowUseProof = false;
  isUseNewCalculation = false;
  rcTotalChargeableWeight = 0;
  rcTotalCustomChargeableWeight = 0;
  rcTotalEstimateChargeableWeight = 0;
  cargoTotalChargeableWeight = 0;
  cargoTotalCustomChargeableWeight = 0;
  cargoTotalEstimateChargeableWeight = 0;
  cargoTotalCustomVolumeWeight = 0;
  cargoTotalCustomGrossWeight = 0;
  cargoTotalGrossWeight = 0;
  cargoTotalVolumeWeight = 0;
  cargoTotalEstimateGrossWeight = 0;
  cargoTotalEstimateVolumeWeight = 0;
  calculateType = "";
  isMinimumVolumePerPiece = false;
  minVolumePerPiece = 0;
  isValidAwbManual = false;
  isCargoDimensionOn = false;
  isDisputeCargo = false;
  cargoCommodityGroupIsElectronicDg = false;
  cargoCommodityGroupIsDg = false;
  cargoCommodityGroupIsQuarantine = false;
  totalDisputeBagging = 0;
  totalBagging = 0;
  isDisputeFromBagging = false;
  isDisputeFromCargo = false;

  // new
  isPrintManifest = false;
  isPrintLabel = false;
  isPrintPti = false;
  isPrintSptj = false;
  isPrintAwb = false;
  trackingStatus = "";
  cargoNog = "";
  totalBagWithWeightDispute = 0;
  isNewForm = false;
  onlyTotalBag = 0;
  onlyTotalStt = 0;
  currentChargeableWeight = 0;
  isFlightVia = false;
  isTransit = false;

  constructor(fields?: Partial<CargoV2Data>) {
    Object.assign(this, fields);
  }

  get isAccountWhitelist() {
    return FlagsPermissionCargo.feature_flight_v2_enable.isEnabled();
  }

  get isUseSabreForRebooking() {
    return this.isAccountWhitelist && this.cargoType === "plane"
      ? false
      : !this.isUseSabre;
  }
}

export class CargoV2SuccessSummaryData {
  plane = "";
  truck = "";
  ship = "";

  constructor(fields?: Partial<CargoV2SuccessSummaryData>) {
    Object.assign(this, fields);
  }
}

export class CargoV2DisputeSummaryData {
  totalCargoDispute = 0;
  totalCargoData = 0;
  totalPercentage = 0;
  totalPlaneDispute = 0;
  totalPlaneData = 0;
  totalPlanePercentage = 0;
  totalTruckDispute = 0;
  totalTruckData = 0;
  totalTruckPercentage = 0;
  totalTrainDispute = 0;
  totalTrainData = 0;
  totalTrainPercentage = 0;
  totalShipDispute = 0;
  totalShipData = 0;
  totalShipPercentage = 0;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<CargoV2DisputeSummaryData>) {
    Object.assign(this, fields);
  }

  get hasDispute() {
    return this.totalCargoDispute > 0;
  }

  get formatDateRange() {
    if (!this.startDate || !this.endDate) return "";

    const start = moment(this.startDate).format("DD MMM");
    const end = moment(this.endDate).format("DD MMM");

    return `${start} - ${end}`;
  }

  get formatDateRangeFull() {
    if (!this.startDate || !this.endDate) return "";

    const start = moment(this.startDate).format("DD MMMM YYYY");
    const end = moment(this.endDate).format("DD MMMM YYYY");

    return `${start} - ${end}`;
  }

  get downloadFileName() {
    const dateStr = moment().format("YYYY-MM-DD");
    return `cargo-dispute-${dateStr}.xlsx`;
  }

  get hasPlaneDispute() {
    return this.totalPlaneDispute > 0;
  }

  get hasTruckDispute() {
    return this.totalTruckDispute > 0;
  }

  get hasShipDispute() {
    return this.totalShipDispute > 0;
  }

  get hasTrainDispute() {
    return this.totalTrainDispute > 0;
  }
}

export class CargoV2MinimumWeightSummaryData {
  totalData = 0;
  totalMinimumVolume = 0;
  totalPercentageMinimumVolume = 0;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<CargoV2MinimumWeightSummaryData>) {
    Object.assign(this, fields);
  }
}

export class CargoV2SummaryInProcessData {
  inProcessTotal = 0;

  constructor(fields?: Partial<CargoV2SummaryInProcessData>) {
    Object.assign(this, fields);
  }
}

export class CargoV2FailedUnread {
  isShow = false;
  newRcId: number[] = [];

  constructor(fields?: Partial<CargoV2FailedUnread>) {
    Object.assign(this, fields);
  }
}

export class OriginData {
  originCode = "";
  originName = "";
  destinationCode = "";
  destinationName = "";

  constructor(fields?: Partial<OriginData>) {
    Object.assign(this, fields);
  }
}

export class ListClientParentData {
  id = 0;
  name = "";
  code = "";

  constructor(fields?: Partial<ListClientParentData>) {
    Object.assign(this, fields);
  }
}

export class ListClientParentEntities {
  pagination = new PaginationV2();
  data: ListClientParentData[] = [];

  constructor(fields?: Partial<ListClientParentEntities>) {
    Object.assign(this, fields);
  }
}

export class RtcSlaData {
  flightDate = "";
  timeRemains = "";

  constructor(fields?: Partial<RtcSlaData>) {
    Object.assign(this, fields);
  }
}

export class RtcData {
  id = 0;
  noReadyToCargo = "";
  totalBagging = 0;
  totalWeight = 0;
  totalPieces = 0;
  cargoType = "";
  minimumWeight = 0;
  maximumWeight = 0;
  originCode = "";
  originName = "";
  destinationCode = "";
  destinationName = "";
  destinationCountryCode = "";
  status = "";
  partnerId = 0;
  partnerType = "";
  partnerCode = "";
  createdAt = "";
  createdName = "";
  updatedAt = "";
  updateName = "";
  hubName = "";
  detail: CargoV2DetailStt[] = [];
  flightsData = [] as FlightDetail[];
  nextFlightsData = [] as FlightDetail[];
  nextConfigCargoFlight = [] as FlightDetail[];
  nextCargoFlightTime = "";
  commodityCode = "";
  commodityName = "";
  productType = "";
  haveConfigCargoFlight = false;
  thresholdTime = 0;
  cutOffTime = "";
  isOpenTooltip = false;
  clientParentName = "";
  totalSttGrossWeight = 0;
  totalSttVolumeWeight = 0;
  totalSttChargeableWeight = 0;
  isUseNewCalculation = false;
  rtcCargoProductType = "";
  isDangerousGoods = false;
  isQuarantine = false;
  isBosspack = false;
  bagOrStt: BagOrSttDetail[] = [];
  rtcCcFlight: any[] = [];
  isMinimumPiece = false;
  isMinimumWeight = false;
  nextRtcFlightConfig: any = {};

  constructor(fields?: Partial<RtcData>) {
    Object.assign(this, fields);
  }

  get convertThresholdTime() {
    if (this.thresholdTime === 0) {
      return flags.cargo_config_flight_treshold_default_value.getValue();
    }
    return this.thresholdTime;
  }

  get isMoreThanCutOffTime(): boolean {
    return !this.cutOffTime && this.cargoType === "plane";
  }

  get cutOffTimeExceededWithoutNextConfig(): boolean {
    return (
      this.isMoreThanCutOffTime &&
      (!this.nextCargoFlightTime || new Date(this.nextCargoFlightTime).getFullYear() === 1)
    );
  }

  get cutOffTimeExceededWithNextConfig(): boolean {
    return (
      this.isMoreThanCutOffTime &&
      (!!this.nextConfigCargoFlight?.[0]?.departureHour || new Date(this.nextCargoFlightTime).getFullYear() !== 1)
    );
  }

  get isNearCutOffTime(): boolean {
    if (!this.cutOffTime) return false;

    const cutoff = new Date();
    const [h, m] = this.cutOffTime.split(":").map(Number);
    cutoff.setHours(h, m, 0, 0);

    if (cutoff <= new Date()) cutoff.setDate(cutoff.getDate() + 1);

    return Date.now() > cutoff.getTime() - 30 * 60 * 1000;
  }

  get nextFlightConfigTreshold() {
    return this.nextFlightsData[0].thresholdTime || 0;
  }
}

export class RtcListEntities {
  pagination = new Pagination(1, 20);
  data: RtcData[] = [];

  constructor(fields?: Partial<RtcListEntities>) {
    Object.assign(this, fields);
  }
}

export const CARGO_V2_STORAGE_KEY = {
  FORM: "form",
  CALCULATE_TYPE: "calculate-type",
  STT_RESULT_FINAL: "cargo",
  SHOW_AIRPORT: "show-select-airport",
  CARGO_BAG: "cargo-bag",
  FLOW_BOOKING: "flow-booking",
  RTC_DETAIL: "rtc-detail",
  NEXT_RTC_DETAIL: "next-rtc-flights-data",
  PROOF_PHOTO_REBOOKING: "proof-photo-rebooking"
};

export class Airport {
  airportCode = "";
  airportName = "";
  cityCode = "";
  cityName = "";
  office = "";
  participantId = "";
  name = "";
  value = "";

  constructor(fields?: Partial<Airport>) {
    Object.assign(this, fields);
  }
}

export class DimensionPieces {
  length = 0;
  width = 0;
  height = 0;
  pieces = 0;
  grossWeight? = 0;
  volumeWeight? = 0;
  sttOrBag? = "";

  constructor(fields?: Partial<DimensionPieces>) {
    Object.assign(this, fields);

    if (fields?.pieces !== undefined) {
      this.pieces = toNumber(fields.pieces);
    }
    if (fields?.length !== undefined) {
      this.length = toNumber(fields.length);
    }
    if (fields?.width !== undefined) {
      this.width = toNumber(fields.width);
    }
    if (fields?.height !== undefined) {
      this.height = toNumber(fields.height);
    }
    if (fields?.grossWeight !== undefined) {
      this.grossWeight = toNumber(fields.grossWeight);
    }
    if (fields?.volumeWeight !== undefined) {
      this.volumeWeight = toNumber(fields.volumeWeight);
    }
  }
}

export class FlightRequest {
  flightNo = "";
  flightDateTime = "";
  flightOrigin = "";
  flightDestination = "";
  remainingCapacity = 0;
  remainingCapacityAllotment = 0;
  remainingCapacityFreesales = 0;
  aircraftInfo = new CargoV2AircraftInfo();
  flightThresholdTime = 0;
  isFlightVia = false;
  isTransit = false;
  sequence = 0;

  constructor(fields?: Partial<FlightRequest>) {
    Object.assign(this, fields);
  }
}

export class BookingPayloadData {
  awbNo = "";
  shcCode = "";
  flightRequest = [] as FlightRequest[];

  constructor(fields?: Partial<BookingPayloadData>) {
    Object.assign(this, fields);
  }
}

export class FormCargoV2 {
  actualDimension = new ActualDimensionData();
  actualTotalCargoGrossweigth = 0;
  actualTotalCargoVolumeweight = 0;
  arrivalDate = "";
  bagOrStt = [] as BagOrSttDetail[];
  bookingPayload = new BookingPayloadData();
  calculateType = "INIT";
  cargoActualPiece = 0;
  cargoCommodity = new OptionsClass();
  cargoNo = "";
  cargoOverCutoffLimit = false;
  cargoRtcTurnAuto = false;
  cargoTotalChargeableWeight = 0;
  cargoTotalCustomChargeableWeight = 0;
  cargoTotalEstimateChargeableWeight = 0;
  cargoType = new OptionsClass();
  cargoVehicleNo = "";
  departureDate = "";
  destinationAirportCode = "";
  destinationCityCode = new OptionsClass();
  dimensions = [] as DimensionPieces[];
  driverSelected = "";
  estimationDimension = new EstimationDimensionData();
  estTotalCargoGrossweigth = 0;
  estTotalCargoVolumeweight = 0;
  hubDistrictCode = "";
  hubId = 0;
  hubName = 0;
  hubOriginCity = "";
  isCargoDimensionOn = false;
  isCargoEdit = false;
  isCargoPlaneManual = false;
  isErroAwb = false;
  isFromRtc = false;
  isNewCalculation = false;
  isRecommended = false;
  isUseNewCalculation = true;
  isUseSabre = false;
  isValidAwbManual = false;
  isValidVehicleNo = false;
  ngenCreatedAt = "";
  nog = "";
  originAirportCode = "";
  originCityCode = "";
  originCountryCode = "";
  partnerName = "";
  partnerType = "";
  photoProof = [] as string[];
  productCargo = "";
  rebookingId = 0;
  route = "";
  rtcId = 0;
  sequentialFlight = 0;
  shc = "";
  shcName = "";
  totalFlight = 0;
  totalPiece = 0;
  totalStt = 0;
  currentChargeableWeight = 0;
  isFlightVia = false;
  isTransit = false;

  constructor(fields?: Partial<FormCargoV2>) {
    Object.assign(this, fields);

    this.originCityCode =
      fields?.originCityCode || LocationController.districtDetail.cityCode;

    // stt
    this.cargoTotalChargeableWeight = Math.max(
      0,
      this.totalAccumulationSttGrossWeightDataTable,
      this.totalAccumulationSttVolumeWeightDataTable
    );

    // actual/custom
    this.actualTotalCargoGrossweigth =
      this.actualTotalCargoGrossweigth ??
      this.totalAccumulationEstimationGrossWeightDataTable;

    this.cargoTotalCustomChargeableWeight = Math.max(
      0,
      toNumber(this.actualTotalCargoGrossweigth),
      toNumber(this.actualTotalCargoVolumeweight)
    );

    // estimation/reweight
    this.estTotalCargoGrossweigth = this.totalAccumulationEstimationGrossWeightDataTable;
    this.estTotalCargoVolumeweight = this.totalAccumulationEstimationVolumeWeightDataTable;
    this.cargoTotalEstimateChargeableWeight = Math.max(
      0,
      this.totalAccumulationEstimationGrossWeightDataTable,
      this.totalAccumulationEstimationVolumeWeightDataTable
    );

    // pieces
    this.cargoActualPiece =
      this.cargoActualPiece ?? this.totalAccumulationActualPieceDataTable;
  }

  // gw estimation/reweight
  get totalAccumulationEstimationGrossWeightDataTable() {
    const value = this.bagOrStt.reduce((total, item: BagOrSttDetail) => {
      if (item.bagData?.bagCustomGrossWeight) {
        return total + item.bagData.bagCustomGrossWeight;
      }
      return total + item.grossWeight;
    }, 0);

    return toNumber(formatInputDecimalOnly2Digits(String(value)));
  }

  // vw estimation/reweight
  get totalAccumulationEstimationVolumeWeightDataTable() {
    const value = this.bagOrStt.reduce((total, item: BagOrSttDetail) => {
      if (item.bagData?.bagCustomVolumeWeight) {
        return total + item.bagData.bagCustomVolumeWeight;
      }
      return total + item.volumeWeight;
    }, 0);

    return toNumber(value);
  }

  // gw stt
  get totalAccumulationSttGrossWeightDataTable() {
    const value = this.bagOrStt.reduce((total, item: BagOrSttDetail) => {
      return total + item.grossWeight;
    }, 0);
    return toNumber(value);
  }

  // vw stt
  get totalAccumulationSttVolumeWeightDataTable() {
    const value = this.bagOrStt.reduce((total, item: BagOrSttDetail) => {
      return total + item.volumeWeight;
    }, 0);
    return toNumber(value);
  }

  // total actual pieces table
  get totalAccumulationActualPieceDataTable() {
    return this.bagOrStt.reduce(
      (sum, item) => sum + (item.bagNo ? 1 : item.sttTotalPiece),
      0
    );
  }

  get normalizeNumber() {
    return normalizePayloadNumber(new FormCargoV2(), this);
  }

  get containsBosspackInDataTable() {
    return this.bagOrStt.some((item) => item.productType === "BOSSPACK");
  }
}

export class BagOrStt {
  sttNo = "";
  bagNo = "";
  reasonCode = "";
  message = "";
  messageEn = "";

  constructor(fields?: Partial<BagOrStt>) {
    Object.assign(this, fields);
  }
}

export class CheckEligibleReadyToCargoV2 {
  isEligible = false;
  bagOrStt: BagOrStt[] = [];

  constructor(fields?: Partial<CheckEligibleReadyToCargoV2>) {
    Object.assign(this, fields);

    if (fields?.bagOrStt) {
      this.bagOrStt = fields.bagOrStt.map((item) => new BagOrStt(item));
    }
  }
}

export class BagResult {
  baggingNumber = "";
  bagGrossWeight = 0;
  stt: CargoV2DetailStt[] = [];

  constructor(fields?: Partial<BagResult>) {
    Object.assign(this, fields);
  }
}

export class ReadyToCargoV2 {
  id = 0;
  noReadyToCargo = "";
  totalBagging = 0;
  totalWeight = 0;
  totalPieces = 0;
  cargoType = "";
  minimumWeight = 0;
  maximumWeight = 0;
  originCode = "";
  originName = "";
  destinationCode = "";
  destinationName = "";
  status = "";
  partnerId = 0;
  partnerType = "";
  partnerCode = "";
  createdAt = "";
  createdName = "";
  updatedAt = "";
  updateName = "";
  hubName = "";
  detail: CargoV2DetailStt[] = [];
  flightsData = [] as FlightDetail[];
  nextFlightsData = [] as FlightDetail[];
  nextConfigCargoFlight = [] as FlightDetail[];
  nextCargoFlightTime = "";
  commodityCode = "";
  commodityName = "";
  productType = "";
  haveConfigCargoFlight = false;
  thresholdTime = 0;
  cutOffTime = "";
  isOpenTooltip = false;
  clientParentName = "";
  totalSttGrossWeight = 0;
  totalSttVolumeWeight = 0;
  totalSttChargeableWeight = 0;
  isUseNewCalculation = false;
  rtcCargoProductType = "";
  constructor(fields?: Partial<ReadyToCargoV2>) {
    Object.assign(this, fields);
  }
  get convertThresholdTime() {
    if (this.thresholdTime === 0) {
      return flags.cargo_config_flight_treshold_default_value.getValue();
    }
    return this.thresholdTime;
  }

  get isMoreThanCutOffTime(): boolean {
    return !this.cutOffTime && this.cargoType === "plane";
  }

  get cutOffTimeExceededWithoutNextConfig(): boolean {
    return (
      this.isMoreThanCutOffTime &&
      !this.nextConfigCargoFlight?.[0]?.departureHour
    );
  }

  get cutOffTimeExceededWithNextConfig(): boolean {
    return (
      this.isMoreThanCutOffTime &&
      !!this.nextConfigCargoFlight?.[0]?.departureHour
    );
  }

  get isNearCutOffTime(): boolean {
    if (!this.cutOffTime) return false;

    const cutoff = new Date();
    const [h, m] = this.cutOffTime.split(":").map(Number);
    cutoff.setHours(h, m, 0, 0);

    // Move cutoff to tomorrow if it's already passed
    if (cutoff <= new Date()) cutoff.setDate(cutoff.getDate() + 1);

    return Date.now() > cutoff.getTime() - 30 * 60 * 1000;
  }

  get nextFlightConfigTreshold() {
    return this.nextFlightsData[0].thresholdTime || 0;
  }
}

export class CalculateVolume {
  width = 0;
  length = 0;
  height = 0;
  volumeWeight = 0;
  chargeableWeight = 0;
  isUploadProofPhoto = false;
  calculateType = "";
  isMaximumDisputeWeight = false;
  maxAllowedCw = 0;

  constructor(fields?: Partial<CalculateVolume>) {
    Object.assign(this, fields);
  }
}

export class FlightDetail {
  DailyFlightSNo = 0;
  FlightNo = "";
  DepartureDateTime = "";
  ArrivalDateTime = "";
  departureHour = "";
  arrivalHour = "";
  flightDate = "";
  Route = "";
  origin = "";
  destination = "";
  transitsData = [] as FlightDetail[];
  airportCodeOrigin = "";
  airportCodeDestination = "";
  flightDayTransit = 0;
  thresholdTime = 0;
  constructor(fields?: Partial<FlightDetail>) {
    Object.assign(this, fields);

    if (!fields?.departureHour) {
      this.departureHour = "";
    }
    if (!fields?.arrivalHour) {
      this.arrivalHour = "";
    }
    if (!fields?.thresholdTime) {
      this.thresholdTime = 0;
    }
  }
  get convertThresholdTime() {
    if (this.thresholdTime === 0) {
      return flags.cargo_config_flight_treshold_default_value.getValue();
    }
    return this.thresholdTime;
  }
}

export class CargoV2ProductData {
  cargoProductTypeId = 0;
  cargoProductTypeCode = "";
  cargoProductTypeStatus = "";

  constructor(fields?: Partial<CargoV2ProductData>) {
    Object.assign(this, fields);
  }
}

export class CalculateData {
  chargeableWeight = 0;
  volumeWeight = 0;
  height = 0;
  isUploadProofPhoto = false;

  constructor(fields?: Partial<CalculateData>) {
    Object.assign(this, fields);
  }
}
export class CargoV2HistoryData {
  date = "";
  items: CargoV2HistoryItem[] = [];

  constructor(fields?: Partial<CargoV2HistoryData>) {
    Object.assign(this, fields);
  }
}

export class CargoV2HistoryItemCargoFlightsDetail {
  cfNumber = "";
  cfFlightNo = "";
  cfAirportOrigin = "";
  cfAirportDestination = "";
  cfEstDepartureTime = "";
  cfEstArrivalTime = "";
  sequence = "";

  constructor(fields?: Partial<CargoV2HistoryItemCargoFlightsDetail>) {
    Object.assign(this, fields);
  }
}

export class CargoV2HistoryItem {
  date = "";
  active = false;
  status = "";
  transitLocation = "";
  districtCity = "";
  description = "";
  koli = 0;
  grossWeight = 0;
  volumeWeight = 0;
  flightCode = "";
  flightDateTime = "";
  arrivalDateTime = "";
  flightDate = "";
  eta = "";
  etd = "";
  departureFlightDate = "";
  arrivalFlightDate = "";
  totalTransit = 0;
  cargoFlightDetails = [] as CargoV2HistoryItemCargoFlightsDetail[];
  

  constructor(fields?: Partial<CargoV2HistoryItem>) {
    Object.assign(this, fields);
  }
}

export class FlightData {
  flightNo = "";
  departureDate = "";
  arrivalDate = "";
  originAirportCode = "";
  destinationAirportCode = "";
  departureTime = 0;
  arrivalTime = 0;
  transitNumber = 0;
  itineraries: FlightData[] = [];
  orderId = 0;
  isDgAllowed = false;
  capacityAvailable = false;
  dimensionAvailable = false;
  historyDepartureStatus = "";

  constructor(fields?: Partial<FlightData>) {
    Object.assign(this, fields);
  }
}

export class AwbDetailData {
  awbDetails: AwbDetail[] = [];
  transitRoute = "";
  shc = "";
  nog = "";
  flightData = new FlightData();
  constructor(fields?: Partial<AwbDetailData>) {
    Object.assign(this, fields);
  }
}

export class CreateCargoV3 {
  cargoNo = "";
  totalSttSuccess = 0;
  totalSttFailed = 0;
  listSttFailed = [] as string[];
  isCargoUsingAwb = false;
  bookingRequestId = "";
  constructor(fields?: Partial<CreateCargoV3>) {
    Object.assign(this, fields);
  }
}

export class CargoTransportType {
  transportLabel = "";
  transportType = "";

  constructor(fields?: Partial<CargoTransportType>) {
    Object.assign(this, fields);
  }
}

export class BagOrSttDetail {
  bagNo = "";
  bagVendorNo = "";
  sttId = 0;
  sttNo = "";
  sttNoElexys = "";
  sttTotalPiece = 0;
  grossWeight = 0;
  bagData = new CargoV2DetailBagData();
  chargeableWeight = 0;
  volumeWeight = 0;
  productType = "";
  commodityId = 0;
  commodityName = "";
  commodityCode = "";
  commodityGroupCode = "";
  commodityGroupName = "";
  commodityGroupIsDg = false;
  isPaid = false;
  regionId = "";
  regionName = "";
  destinationCityCode = "";
  destinationCityName = "";
  destinationDistrictCode = "";
  destinationDistrictName = "";
  shcCode = "";
  shcName = "";
  shcDescription = "";
  sttAssessmentStatus = "";
  sttPieces = [] as CargoV2DetailSttPiece[];
  isDangerousGoods = false;
  isQuarantine = false;
  commodityGroupIsQuarantine = false;
  sttDetails = [] as BagOrSttDetail[];
  shipmentId = "";
  bagChargeableWeight = 0;
  action = "";
  bagPhotoProof: string[] = [];
  baggingNumber = "";
  baggingVendorNumber = "";
  baggingVendorNo = "";
  sttChargeableWeight = 0;
  isDisputeBagging = false;
  sttShipmentId = "";
  sttClientId = 0;
  destinationCountryCode = "";

  constructor(fields?: Partial<BagOrSttDetail>) {
    Object.assign(this, fields);
  }
}

export class ScanDetail {
  isAllowUpdateStatus = false;
  bagOrStt: BagOrSttDetail[] = [];
  lastStatus = "";
  isBosspack = false;
  isDangerousGoods = false;
  errorMessage = "";
  errorMessageEn = "";

  constructor(fields?: Partial<ScanDetail>) {
    Object.assign(this, fields);

    if (fields?.bagOrStt) {
      this.bagOrStt = fields.bagOrStt.map((item) => new BagOrSttDetail(item));
    }
  }
}
